import React from "react";
import RecyclingStoreTopList from "./RecyclingStoreTopList";
import {RecyclingStoreTopListAppProps} from "./types";
import {getLocale} from "@apps/Shared/Utils/Utils";
import {useGetRecyclingStoreTopListBlockQuery} from "@apps/Shared/GraphQL/generated";

function App(props: RecyclingStoreTopListAppProps): JSX.Element {
    const id = props.id;
    const locale = getLocale();


    const {data: recyclingStoreTopListData} = useGetRecyclingStoreTopListBlockQuery({
        id: id,
        locale: [locale],
    });

    const recyclingStoreTopListItem =
        recyclingStoreTopListData?.RecyclingStoreTopListBlockModel?.items?.[0] ?? null;

    return recyclingStoreTopListItem ? (
        <RecyclingStoreTopList
            heading={
                recyclingStoreTopListItem.Heading ?? undefined
            }
            description={
                recyclingStoreTopListItem.TopListDescription?.Html ?? undefined
            }
        />
    ) : (
        <></>
    );

}

export default App;
